import React from 'react';
import numeral from 'numeral';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../../../state/fetch-dux';
import TwomeyPNG from '../../../../styles/images/twomey-brand-cartitem.png';
import SilveroakPNG from '../../../../styles/images/so-brand-cartitem.png';
import CookieLink from '../../../ui/CookieLink';

const formatMoney = p => numeral(p || 0).format('$0,0.00');

const REACT_APP_SILVEROAK_LINK = `${process.env.REACT_APP_SILVEROAK_LINK}`;

const getLabel = volumeInml => {
  switch (volumeInml) {
    case 750:
      return '750ml';
    case 1500:
      return '1.5L';
  }
};

const getImageHref = (
  {
    imageHref
  }
) => `${imageHref}`;

const CartItem = (
  {
    brandingId,
    imageHref,
    unitPrice,
    kitMarkdown,
    qty,
    volumeInml,
    handleRemoveItem,
    shoppingCartItemId,
    putCartItem,
    skuDescription,
    clubContinuityTypeId,
    productHref,
    productHrefBase,
    cartLimit
  }
) => {
  const onRemoveItem = e => {
    e.preventDefault();
    handleRemoveItem(shoppingCartItemId);
  };
  const handleQtyChange = e => {
    const { value } = e.target || {};
    putCartItem({
      id: shoppingCartItemId,
      payload: { qty: parseInt(value) }
    });
  };

  const imgSrc = getImageHref({ imageHref, clubContinuityTypeId });

  return (
    <div className="cart-item">
      <div className="form-row">
        <div className="col-3">
          <img src={imgSrc} alt={skuDescription} style={{ width: '130px' }} />
        </div>
        <div className="col-9">
          <div className="row">
            <div className="col-3 col-md-2">
              {brandingId === 2 &&
                <img src={TwomeyPNG} alt="Twomey" className="brand-logo" />}
              {brandingId === 1 &&
                <img
                  src={SilveroakPNG}
                  alt="Silver Oak"
                  className="brand-logo"
                />}
            </div>
            <div className="col-md-8">
              <h3>
                {brandingId === 1 &&
                  <CookieLink
                    href={`${REACT_APP_SILVEROAK_LINK}${productHref}`}
                    label={skuDescription}
                  />}
                {brandingId === 2 &&
                  <Link to={productHref}>{skuDescription}</Link>}
              </h3>
              <div className="row cart-details">
                <div className="col-md-6">
                  {/* Format: {getLabel(volumeInml)}<br /> */}
                  Price: {formatMoney(unitPrice - (kitMarkdown || 0))}
                </div>
                <div className="col-md-6">
                  Quantity:
                  <label className="sr-only">Quantity</label>
                  <select value={qty} onChange={handleQtyChange}>
                    {Array.from(Array(cartLimit)).map((quantity, index) => (
                      <option value={index + 1} key={index}>
                        {index + 1}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a href="#" className="remove-cart-item" onClick={onRemoveItem}>
        × Remove
      </a>
      <span className="total-price">{formatMoney((unitPrice - (kitMarkdown || 0) )* qty)}</span>
    </div>
  );
};

const mapState = state => {
  return {};
};

const mapDipatch = dispatch =>
  bindActionCreators(
    {
      putCartItem: fetchDux.putCartItem.createAction
    },
    dispatch
  );

export default connect(mapState, mapDipatch)(CartItem);
